import React, { useState } from "react";

function Legenda() {
  const [showLegenda, setshowLegenda] = useState(false);
  return (
    <>
      <div className="uk-position-absolute legenda-wrap">
        {showLegenda && (
          <div className="legenda">
            <ul className="uk-list uk-margin-remove">
              <li className="vendita">Vendita con Agente</li>
              <li className="affitto">Affitto con Agente</li>
              <li className="privati">Privati</li>
            </ul>
          </div>
        )}
        <div className="uk-margin-small-top">
          <button
            type="button"
            className="uk-icon-button"
            uk-icon="icon: info; ratio: 1.5"
            onClick={() => setshowLegenda(!showLegenda)}
            aria-label="Toggle Legenda"
          ></button>
        </div>
      </div>
    </>
  );
}

export default Legenda;
